import { cme_kurs } from './Global/Kurs'
import { this_device } from './Global/Device'
import { jumpToCoursePart } from './Global/functions'
import { mainVideo } from './Global/Video'


export const VideoOverlay = ({ slides, courseIndex, setCourseIndex, setCurrentVideoTime, slidesAmount }) => {
    return (
        <>
            {/* ----- overlay for video controls ----- */}
            < div className="presentation-overlay overlay-active" onClick={() => mainVideo.toggleOverlay()} >

                {/* select course part */}
                < div className="course-parts-container" onClick={(e) => (e.stopPropagation())}>
                    {
                        Array.apply(null, Array(cme_kurs.partsAmount)).map((item, index) => (

                            // if there are more parts display this
                            (cme_kurs.partsAmount > 1) ?
                                <div
                                    key={"part-reiter-" + index}
                                    active={(index === courseIndex) ? "true" : "false"}
                                    onClick={() => jumpToCoursePart(index, setCourseIndex, setCurrentVideoTime)}
                                    className="reiter">
                                    Teil {index + 1}
                                </div>

                                : <div key={"part-reiter-" + index}></div >
                        ))
                    }
                </div >


                {/* play and +/-10seconds */}
                < div className="vc_container_play" >
                    <button className="overlay-btn container-shadow" onClick={(e) => mainVideo.minus10secs(e)}>-10 Sek</button>
                    <div href="#" className="play-btn container-shadow" onClick={(e) => mainVideo.togglePlayPause(e)}><div className="play-pause-icon-box playicon"></div></div>
                    <button className="overlay-btn container-shadow" onClick={(e) => mainVideo.plus10secs(e)}>+10 Sek</button><br />
                </div >


                {/* main video controls */}
                < div className="vc_container_inner_dark" >
                    <div className="container">
                        <div className="row video-controls-container">

                            {/* current chart & previous-chart */}
                            <div className="vc_container_20">
                                {(!cme_kurs.isBigVideo) ?
                                    <>
                                        <div className="formated-video-time float-start d-none d-lg-block"><b className="chart_nr_active">1</b> von {slidesAmount}</div>
                                        <div className="vc_icon_prev vc_icon float-end" onClick={(e) => mainVideo.gotoPrevChart(e, slides)}></div>
                                    </>
                                    :
                                    ""}

                            </div>
                            {/* video timebar */}
                            <div className="vc_container_35 video-timebar-container">
                                <div className="vc-inner-container">
                                    <input className="video-slider" onClick={(e) => e.stopPropagation()} onInput={(e) => mainVideo.seekVideoPos(e)} defaultValue={0} type="range" min="0" max="100" steps="1" />
                                    <div className="video-past-time-bar"></div> {/* for nicer visualization */}
                                </div>
                            </div>

                            {/* next chart & videotime */}
                            <div className="vc_container_25">
                                {(!cme_kurs.isBigVideo) ?
                                    <div className="vc_icon_next vc_icon float-start" onClick={(e) => mainVideo.gotoNextChart(e, slides)}></div>
                                    :
                                    ""}
                                <div className="formated-video-time float-start d-none d-lg-block">

                                    {/* format current videotime for nicer look */}
                                    <span className="currentVideoTime" ><b>00:00</b></span>
                                    {/* video duration will be inserted here in mainVideo.init */}
                                    /<span className="videoDuration"></span>

                                </div>
                            </div>

                            {/* audio & presentation buttons */}
                            <div className="vc_container_20">
                                <div className="vc_icon float-end vc_icon_fullscreen" onClick={(e) => mainVideo.toggleFullScreen(e)}></div>

                                {(!cme_kurs.isBigVideo) ? <div className="vc_icon float-end vc_icon_presentation d-none d-lg-block" onClick={(e) => mainVideo.togglePresentationMode(e)}></div> : <></>}

                                {/* dont display audio button if device is a tablet or phone */}
                                {
                                    (this_device.deviceType === "desktop" && !this_device.isTouchDevice) ?
                                        <div className="vc_icon video-audio-input float-end vc_icon_volume-max pl-2  d-none d-lg-block" onClick={(e) => e.stopPropagation()}>
                                            <input className="audio-slider" onInput={(e) => mainVideo.changeVolume(e)} defaultValue={100} type="range" min="0" max="100" steps="1" />
                                        </div>
                                        :
                                        ""
                                }
                            </div>
                        </div>

                    </div>
                </div >

            </div >
        </>
    )
}

export default VideoOverlay